import styles from './EmergencyInfo.module.css';
import { useFormContext } from 'react-hook-form';
import { ControllerInputSelect, InputTextCleaner } from '../../../../../forms/react-hook-form';
import { FormDataApis, REGEXP_CLEAN, SelectOptions } from '../../../ApisForm.model';
import { InputCheckbox } from '../../../../../forms/input-checkbox';
import { Text } from '../../../../../foundations/text';
import { REGEXP_PHONE } from '../ContactData.model';
import { useTranslation } from 'react-i18next';
import { FormEmergencyInfo, REGEXP_NAME } from './EmergencyInfo.model';
import { useContext, useEffect } from 'react';
import { ApisFormContext } from '../../../ApisForm.utils';
import { EmergencyInfoFields } from '../../../ApisForm.constants';

export const EmergencyInfo = () => {
	const { t } = useTranslation(['contact-data', 'common']);
	const { register, setValue } = useFormContext<FormDataApis>();
	const { listOptions, isFormDisabled = false, contactData, isMultiPassengers } = useContext(ApisFormContext);
	const isRequired = contactData?.emergencyInfo.name.required ?? false;

	useEffect(() => {
		if (contactData?.emergencyInfo) {
			const { number, name, checkEmergencyAll, phone } = contactData.emergencyInfo;
			const countryCode = listOptions.countryCode?.find((item) => item.value === phone.value);
			const updateData: FormEmergencyInfo = {
				number: number.value,
				name: name.value,
				checkEmergencyAll: checkEmergencyAll
			};
			setValue(EmergencyInfoFields.MODEL, updateData);
			if (countryCode) setValue(EmergencyInfoFields.PHONE, countryCode);
		}
	}, [contactData?.emergencyInfo]);

	return (
		<div className={styles.box_container}>
			<Text as="p" font="verdana" className={styles.box_title}>
				{t('EMERGENCY_TITLE')}: {t('EMERGENCY_SUBTITLE')} {isRequired ? '' : t('common:OPTIONAL')}
			</Text>
			<div className={styles.box_content}>
				<div data-testid="emergency-phone-prefix" className={styles.box_input}>
					<ControllerInputSelect
						name={EmergencyInfoFields.PHONE}
						label={t('PHONE_PREFIX')}
						options={listOptions.countryCode as SelectOptions[]}
						rules={{ required: isRequired ? t('PHONE_PREFIX_ERR') : undefined }}
						disabled={isFormDisabled}
					/>
				</div>
				<div className={styles.box_input}>
					<InputTextCleaner
						{...register(EmergencyInfoFields.NUMBER, {
							required: isRequired ? t('PHONE_VALID_ERR') : undefined,
							pattern: {
								value: REGEXP_PHONE,
								message: t('PHONE_VALID_ERR')
							},
							maxLength: 16
						})}
						type="number"
						name={EmergencyInfoFields.NUMBER}
						label={t('PHONE_NUMBER')}
						className={styles.box_input_text}
						labelStyles={styles.labelStyles}
						disabled={isFormDisabled}
						regexCleaner={REGEXP_CLEAN}
					/>
				</div>
				<div className={styles.box_input}>
					<InputTextCleaner
						{...register(EmergencyInfoFields.NAME, {
							required: isRequired ? t('CONTACT_NAME_ERR') : undefined,
							pattern: {
								value: REGEXP_NAME,
								message: t('CONTACT_NAME_ERR')
							},
							maxLength: 30
						})}
						name={EmergencyInfoFields.NAME}
						label={t('CONTACT_NAME')}
						className={styles.box_input_text}
						labelStyles={styles.labelStyles}
						disabled={isFormDisabled}
						regexCleaner={REGEXP_CLEAN}
					/>
				</div>
			</div>

			{isMultiPassengers && (
				<InputCheckbox
					{...register(EmergencyInfoFields.USE_ALL)}
					name={EmergencyInfoFields.USE_ALL}
					label={t('USE_FOR_ALL_PASSENGERS')}
					className={styles.box_Checkbox}
					disabled={isFormDisabled}
				/>
			)}
		</div>
	);
};
